import { HeaderFixed } from '@/components';
import { JarFilterButtons } from './JarFilterButtons';
import { JarSearchBox } from './JarSearchBox';
import { css } from '@emotion/css';

export const JarHeader: React.FC = () => (
  <HeaderFixed className={cn.contentShadows}>
    <JarSearchBox />
    <JarFilterButtons />
  </HeaderFixed>
);

const cn = {
  contentShadows: css`
    box-shadow: 0 1px 8px 0 rgba(0, 0, 0, 0.2);
    margin-bottom: 24px;
  `
}
